import { GeneralAction } from '../../../../shared/infrastructure/store/actions/general_action';
import { TransactionActionTypes as actions } from '../actions/actionTypes';
import { initialTransactionState } from '../state/state';

const Transactions = (state = initialTransactionState, action: GeneralAction<actions>) => {
    switch (action.type) {
        case actions.SET_PAYMENT_DETAILS:
            state = { ...state, paymentDetails: action.payload };
            break;
        case actions.SET_PAYMENT:
            state = {
                ...state,
                payment: action.payload,
                laodingPayment: false
            };
            break;
        case actions.DOWNLOAD_CSV:
            state = { ...state, loading: true };
            break;
        case actions.DOWNLOAD_CSV_FAILURE:
            state = { ...state, loading: false, error: action.payload };
            break;
        case actions.DOWNLOAD_CSV_SUCCESS:
            state = { ...state, loading: false, downloaded: action.payload };
            break;
        case actions.SAVE_TRANSACTION_FILTER:
            state = { ...state, filterPersistence: action.payload };
            break;
        case actions.CLEAR_TRANSACTION_FILTER:
            state = { ...state, filterPersistence: null };
            break;
        default:
            break;
    }
    return state;
};

export default Transactions;
